import { render, staticRenderFns } from "./NsSlottedDropdownModal.vue?vue&type=template&id=12b4daae&scoped=true&"
import script from "./NsSlottedDropdownModal.vue?vue&type=script&lang=js&"
export * from "./NsSlottedDropdownModal.vue?vue&type=script&lang=js&"
import style0 from "./NsSlottedDropdownModal.vue?vue&type=style&index=0&id=12b4daae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b4daae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12b4daae')) {
      api.createRecord('12b4daae', component.options)
    } else {
      api.reload('12b4daae', component.options)
    }
    module.hot.accept("./NsSlottedDropdownModal.vue?vue&type=template&id=12b4daae&scoped=true&", function () {
      api.rerender('12b4daae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/design-components/src/components/NsSlottedDropdownModal.vue"
export default component.exports